import React from "react";
import BodyText from "@shared/ui/BodyText";
import MakulaLogoIcon from "@shared/svg/makula-logo-dark.svg?react";

interface SignUpFormHeaderProps {
  title: string;
  subtitle: string;
}

export const SignUpFormHeader: React.FC<SignUpFormHeaderProps> = ({
  title,
  subtitle,
}) => {
  return (
    <div className="mb-4xl">
      <MakulaLogoIcon className="w-[38px] h-[48px] mb-2xl" />
      <BodyText className="!text-2xl font-bold mb-sm">{title}</BodyText>
      <BodyText color="text-secondary">{subtitle}</BodyText>
    </div>
  );
};
